export function expandedToastOffset(index, heights, gap) {
  let heightBefore = 0;
  for (let i = 0; i < index; i += 1) {
    heightBefore += heights[i] ?? 0;
  }
  return heightBefore + index * gap;
}
export function expandedStackHeight(heights, gap) {
  if (heights.length === 0) return 0;
  const totalHeights = heights.reduce((sum, height) => sum + height, 0);
  return totalHeights + Math.max(0, heights.length - 1) * gap;
}
export function collapsedStackHeight(frontHeight, peekCount, gap) {
  if (peekCount <= 0) return 0;
  return frontHeight + Math.max(0, peekCount - 1) * gap;
}